// DS: CR17, CMPST05
import React from 'react';
import classnames from 'classnames';
import { Props as StandardThumbProps } from '../Standard';
import Content, { Props as ContentProps } from './_partials/Content';
import PanelC33C, { Props as PanelProps } from '../Shop/_partials/PanelC33C';
import { getDeviationType } from '../../_helpers';
import { DeviationTypes } from '../../../types/deviation';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';

import s from '../Shop/ShopThumb.scss';

export const PANEL_HEIGHT = 82;
export const DEFAULT_THUMB_HEIGHT = 337;

export type Props = PanelProps & ContentProps & StandardThumbProps;

/**
 * Editor only version of Shop thumb
 */
const ShopThumb: React.FC<Props> = ({
  deviation,
  price,
  priceLabel = 'shop.thumb.points',
  priceLabelOnTop = false,
  showAuthor = true,
  width,
  height,
  disabled,
  disabledLabel,
  style,
  textContent,
  dollarsCost,
  addLink = true,
}) => {
  const effectiveHeight = height || DEFAULT_THUMB_HEIGHT + PANEL_HEIGHT;
  const isCommission =
    getDeviationType(deviation) === DeviationTypes.COMMISSION;
  const isSmall = effectiveHeight < 150;
  return (
    <div
      className={classnames(s['root'], disabled && s['disabled'])}
      style={{ width, height: effectiveHeight, ...style }}
    >
      <ErrorBoundary debugComponent="ShopThumb">
        <Content
          deviation={deviation}
          textContent={textContent}
          width={width}
          height={isSmall ? effectiveHeight : effectiveHeight - PANEL_HEIGHT}
          disabled={disabled}
          disabledLabel={disabledLabel}
          addLink={addLink}
          showTitle={isSmall}
        />
        {!isSmall && (
          <PanelC33C
            deviation={deviation}
            price={price}
            priceTextClassName={s['footer-price']}
            priceLabel={priceLabel}
            priceLabelOnTop={priceLabelOnTop}
            showAuthor={showAuthor}
            showTimestamp={!isCommission}
            dollarsCost={dollarsCost}
            addLink={addLink}
          />
        )}
      </ErrorBoundary>
    </div>
  );
};
ShopThumb.displayName = 'ShopThumb';

export default ShopThumb;
